<template>
  <div>
    <div class="error" v-if="fetchState.error">
      <h1>Oeps! Er ging iets mis...</h1>
    </div>
    <slot v-else></slot>
  </div>

</template>

<script>
import {useStore} from "vuex";
import {computed} from 'vue'

export default {
  name: "CatchError",
  props: ['childComponent'],
  setup() {
    const store = useStore()
    const fetchState = computed(() => store.state.fetchState)
    return {
      fetchState,
    }
  }
}
</script>